<template>
  <div class="record s-mb-3">
    <div>
      <div class="record__title">{{ title }}</div>
      <div class="record__desc">
        <div class="record__date">{{ dateLabel }} {{ date }}</div>
      </div>
    </div>
    <div class="s-flex s-flex-col s-items-end">
      <p v-if="showTypeInfo">
        <span class="s-tag">{{ typeText }}</span>
      </p>
      <p class="s-text-primary" :class="{ record__point: !showTypeInfo }">
        <span class="s-font-bold">{{ pointNeedText }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    dateLabel: {
      type: String,
      default: "交易日期",
    },
    showTypeInfo: {
      type: Boolean,
      default: true,
    },
    typeText: {
      type: String,
      default: "",
    },
    pointNeedText: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.record {
  box-shadow: rgb(from var(--s-primary) r g b / 0.2) 0px 2px 8px 0px;
}
</style>

<style lang="scss" scoped>
.record {
  border-bottom: 1px solid #e5e5ea;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 5px;

  &__title {
    font-weight: 600;
    font-size: 18px;
    line-height: 18px;
    color: #2c2c2e;
    margin-bottom: 8px;
  }

  &__desc {
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    color: #979797;
    div {
      margin-bottom: 8px;
    }
  }

  &__point {
    font-weight: 600;
    font-size: 20px;
    line-height: 20px;
  }
}
</style>
